import React from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useState } from 'react';

const WhatsAppButton = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const phoneNumber = "5527997580648";
  const message = "Olá! Gostaria de mais informações sobre os serviços da Well Cargo.";

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {isTooltipVisible && (
        <div className="absolute bottom-16 right-0 bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 w-64 animate-fade-in">
          <button
            onClick={() => setIsTooltipVisible(false)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          >
            <X size={16} />
          </button>
          <p className="text-gray-700 dark:text-gray-200 text-sm mb-3">
            Precisa de ajuda? Fale conosco pelo WhatsApp!
          </p>
          <button
            onClick={handleClick}
            className="w-full bg-[#25D366] text-white py-2 px-4 rounded-lg text-sm font-medium hover:bg-[#20bd5a] transition-colors"
          >
            Iniciar conversa
          </button>
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={() => setIsTooltipVisible(!isTooltipVisible)}
        className="group relative bg-[#25D366] hover:bg-[#20bd5a] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
        onMouseEnter={() => setIsTooltipVisible(true)}
      >
        {/* Pulse Animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25"></span>
        
        <MessageCircle size={28} className="relative z-10" />
      </button>
    </div>
  );
};

export default WhatsAppButton;
